module.exports = __webpack_public_path__ + "static/icare-overlay.98889a76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/icare-overlay.png
// module id = 669
// module chunks = 35783957827783